import CheckboxWidget from './CheckboxWidget.jsx';
import SelectWidget from './SelectWidget.jsx';

// TextWidget/UpDownWidget aren't listed here — @rjsf/core's own default TextWidget/
// UpDownWidget both delegate to `templates.BaseInputTemplate` (see @rjsf/core's
// TextWidget.tsx), which we already override in ../Templates, so string/number fields
// pick it up automatically without needing a widget-level override too.
export const generateWidgets = () => ({
  CheckboxWidget,
  SelectWidget,
});
